import type { SignInCodeChannel, SignInIdentifier } from '@chukua/common';

/** What was typed is the channel people look at first: an email reads its inbox, a mobile WhatsApp before a text. */
const PREFERENCE: Record<SignInIdentifier['kind'], readonly SignInCodeChannel[]> = {
  email: ['email', 'whatsapp', 'sms'],
  phone: ['whatsapp', 'sms', 'email'],
};

/** The channel a code goes by first for what was typed; null only when nothing is offered. */
export function signInChannelFor(kind: SignInIdentifier['kind'], offered: readonly SignInCodeChannel[]): SignInCodeChannel | null {
  return PREFERENCE[kind].find((channel) => offered.includes(channel)) ?? null;
}

/** The channels the code step offers to send by instead, in the server's order. */
export function otherSignInChannels(offered: readonly SignInCodeChannel[], current: SignInCodeChannel): SignInCodeChannel[] {
  return offered.filter((channel) => channel !== current);
}
